import {
  SwipeableDrawer as MuiSwipeableDrawer,
  SwipeableDrawerProps as MuiSwipeableDrawerProps,
} from '@material-ui/core';
import { useTheme } from '@emotion/react';
import React from 'react';

export interface DrawerProps extends MuiSwipeableDrawerProps {
  test?: boolean;
}

const Drawer: React.FunctionComponent<DrawerProps> = ({ anchor = 'right', ...rest }) => {
  const { duration } = useTheme().timings;

  const shorter = parseInt(duration.shorter, 10);
  const slow = parseInt(duration.slow, 10);

  // ...rest, in this case, includes children
  return (
    <MuiSwipeableDrawer
      BackdropProps={{
        style: { backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)' },
        transitionDuration: { enter: slow, exit: shorter },
      }}
      anchor={anchor}
      {...rest}
    />
  );
};

export default Drawer;
